import React from 'react';

interface Props {
  fillColor: string;
}

const StoolLittleSoft = ({ fillColor }: Props) => {
  return (
    <svg width='33' height='16' viewBox='0 0 33 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.1535 0.857239C9.73138 1.76187 10.3941 3.18474 8.66881 4.73426C7.12642 6.11946 5.18909 5.87293 4.65633 8.35279C3.93446 11.7129 12.4868 15.7812 15.6324 15.5899C18.7781 15.3985 20.0565 13.5345 23.1857 13.1344C24.6965 12.9413 25.2788 13.5554 26.6085 12.7467C27.6709 12.1006 27.0482 10.9093 27.6707 10.0328C28.4969 8.86973 32.0467 10.6098 32.2737 8.86973C32.7458 5.25118 26.0658 5.61844 21.7697 3.70039C19.0348 2.47937 16.0245 0.0983036 13.1535 0.857239Z'
        fill={fillColor}
      />
      <path
        d='M0.0310275 13.4996C0.2778 11.9079 1.77917 11.5869 3.38416 11.6307C5.43012 11.6865 8.03493 12.9654 7.23394 14.3717C6.73719 15.2438 5.38241 14.5802 4.0051 14.8701C2.78846 15.1261 2.03186 15.8668 1.14874 15.493C0.0894153 15.0447 -0.0848733 14.2471 0.0310275 13.4996Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolLittleSoft;
